<template>
  <div>
    <b-table
      class="mb-0"
      striped
      small
      hover
      responsive
      :items="innerValue.discounts"
      :fields="fields"
      :show-empty="innerValue.discounts && !innerValue.discounts.length"
      :empty-text="$gettext('no results found')"
    >
      <template v-slot:head(buttons)>
        <b-btn
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="edit()">
          <fa-icon icon="plus"/>
          <translate>add</translate>
        </b-btn>
      </template>
      <template v-slot:cell(buttons)="{ index }">
        <edit-delete-buttons
          @edit="edit(index)"
          @remove="remove(index)"
        />
      </template>
    </b-table>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      button-size="sm"
      size="lg"
      ref="modal"
      :lazy="true"
      :title="objIndex !== undefined ? $gettext('edit') : $gettext('add')"
      @ok.prevent="save"
      >
      <template v-slot:modal-footer>
        <modal-buttons
          :type="objIndex !== undefined ? 'update' : 'add'"
          @save="save"
          @cancel="cancel"
        />
      </template>
      <ValidationObserver ref="modalForm" slim>
        <Form
          v-model="obj"
          @save="save"/>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
import vModelMixin from '@/shared/mixins/v-model'
import cloneDeep from 'lodash/cloneDeep'
import Form from './DiscountEdit.vue'

export default {
  components: {
    Form,
  },
  mixins: [vModelMixin],
  data() {
    return {
      sortBy: null,
      sortDirection: null,
      fields: [
        {
          key: 'label',
          label: this.$gettext('label'),
        },
        {
          key: 'percentage',
          label: this.$gettext('percentage'),
          formatter: (value) => `${value} %`,
        },
        {
          key: 'valid_from',
          label: this.$gettext('valid from'),
          formatter: (value) => this.$options.filters.date(value),
        },
        {
          key: 'valid_to',
          label: this.$gettext('valid from'),
          formatter: (value) => this.$options.filters.date(value),
        },
        { key: 'buttons', label: '' },
      ],
      objIndex: null,
      obj: {},
    }
  },
  methods: {
    edit(index) {
      this.objIndex = index
      if (index !== undefined) this.obj = cloneDeep(this.innerValue.discounts[index])
      else this.obj = {}
      this.$refs.modal.show()
    },
    async remove(index) {
      const accepted = await this.$confirmModal()

      if (accepted) {
        this.innerValue.discounts.splice(index, 1)
        this.$toastDeleteSuccess()
      }
    },
    async save() {
      const isValid = await this.$refs.modalForm.validate()
      if (isValid) {
        if (this.objIndex !== undefined) {
          this.innerValue.discounts.splice(this.objIndex, 1, this.obj)
        } else {
          this.innerValue.discounts.push(this.obj)
        }
        this.$toastSaveSuccess()
        this.cancel()
      } else {
        this.$toastInvalidForm()
      }
    },
    cancel() {
      this.$refs.modal.hide()
    },
  },
}
</script>
